import coTerminationStyle from './co-termination.module.css';

import { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { Table } from 'react-bootstrap';
import FileSaver from 'file-saver';

// Component
import Button from '../../../../components/Button';
import LinkerWithA from '../../../../components/LinkerWithA';
import TooltipDialog from '../../../../components/TooltipDialog';

// Model
import RemainDateModal from './modals/RemainDate.js';

// Slice
import { uiActions } from "../../../../stores/slice/ui";
import {
  getCoTermData,
  getCalculateData,
  postToCoTerm,
  getDownloadCoTerm
} from "../../../../stores/slice/coTermination";
import { selectManagedOrg } from "../../../../stores/slice/pageContext";


const ExpirationDateContainer = props => {
  const { t } = useTranslation();
  const data = { ...props.expirationDate };
  return (
    <div className={coTerminationStyle['expiration-date-container']}>
      {/* 1. Executed field */}
      {data.showExecutedCoTrem && (
        <div className={`${coTerminationStyle['executed-container']} mb-4`}>
          <div className='sub-title mb-2'>{t('4d29676394')}</div>
          <div className={coTerminationStyle['expiration-container']}>
            <div className={coTerminationStyle['expiration-r']}>
              <div><strong>{data.expirationDate}</strong></div>
              <div>{data.expirationYear}</div>
            </div>
            <div className={coTerminationStyle['expiration-l']}> {t('06d2e8b41b')} {data.lastCoterminationDate} </div>
          </div>
        </div>
      )}

      {/* 2. Available field */}
      {data.showAvailable && (
        <div className={`${coTerminationStyle['executed-container']} mb-4`}>
          <div className='sub-title mb-2'>{t('4d29676394')}</div>
          <div className={coTerminationStyle['expiration-container']}>
            <div className={coTerminationStyle['expiration-r']}>
              <div><strong>{t('84314cf72f')}</strong></div>
            </div>
            <div className={coTerminationStyle['expiration-l']}>{t('20997bee16')}</div>
          </div>
        </div>
      )}

      {/* 3. Unavailable field */}
      {data.showUnavailable && (
        <div className={`${coTerminationStyle['executed-container']} mb-4`}>
          <div className='sub-title mb-2'>{t('4d29676394')}</div>
          <div className={coTerminationStyle['expiration-container']}>
            <div className={coTerminationStyle['expiration-r']}>
              <div><strong>{t('84314cf72f')}</strong></div>
            </div>
            <div className={coTerminationStyle['expiration-l']}>{t('ad187df6e5')}</div>
          </div>
        </div>
      )}
    </div>
  )
}

const LicenseStatusContainer = props => {
  const { isShowRemainDateContainer, setShowRemainDateContainer, downloadCoTerm } = props;
  const data = { ...props.coTerminationData };
  const { t } = useTranslation();
  return (
    <div className={coTerminationStyle['license-status-container']}>
      {data && (
        <>
          <div className='mb-2'>
            <span className='sub-title'>{t('213b060157')}</span>
            <TooltipDialog className='ms-2' placement='right' title={t('3cac988ae1')}></TooltipDialog>
          </div>
          <Table responsive className='table-container'>
            <thead>
              <tr>
                <th>#</th>
                <th>{t('402d4d2bce')}</th>
                <th>{t('a4b6321e28')}</th>
                <th>{t('cbc6dad734')}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>DBA-series</td>
                <td>{data.DBA.quantity}</td>
                <td>{data.DBA.unusedActivelicense}</td>
              </tr>
              <tr>
                <td>2</td>
                <td>DBS-2000</td>
                <td>{data.DBS.quantity}</td>
                <td>{data.DBS.unusedActivelicense}</td>
              </tr>
              <tr>
                <td>3</td>
                <td>DBG-2000</td>
                <td>{data.DBG.quantity}</td>
                <td>{data.DBG.unusedActivelicense}</td>
              </tr>
            </tbody>
          </Table>
        </>
      )}
      <div className={coTerminationStyle['co-term-button-group-container']}>
        {data.expiration.canCoTrem && (
          <Button
            label={t('55ea8a95a3')}
            className='btn-grey-blue'
            onClick={() => setShowRemainDateContainer(!isShowRemainDateContainer)}
          />
        )}
        {data.expiration.canDownloadCoTerm && (
          <Button
            label={t('4e806979c8')}
            className='btn-grey-blue'
            onClick={() => downloadCoTerm()}
          />
        )}
      </div>
      <div>
        <LinkerWithA
          label={t('ffc9d85596')}
          href='https://tutorials.nuclias.com/License-co-termination-instructions.html'
          target='_blank'
          className='linker-blue text-decoration-underline fw-normal'
        />
      </div>
    </div>
  )
}

const RemainDateContainer = props => {
  const { isShowRemainDateContainer, setOpenRemainDateModal } = props;
  const showHideClass = isShowRemainDateContainer ? coTerminationStyle['show'] : '';
  const data = { ...props.calculateDate };
  const { t } = useTranslation();

  return (
    <div className={`${coTerminationStyle['remain-date-container']} ${showHideClass}`}>
      <div>
        <div className={coTerminationStyle['remain-date-expiration']}>
          <span> {t('fd10eed5f4')} : </span>
          <span>{data.expirationData}</span>
        </div>
        <div className={coTerminationStyle['remain-date-remaining']}>
          <span>{t('9cc9000385')} : </span>
          <span>{data.remainDay} {t('44fdec4703')}</span>
        </div>
        <Button
          label={t('8649289a44')}
          className='btn-grey-blue mt-3'
          onClick={() => setOpenRemainDateModal(true)}
        />
      </div>
    </div>
  )
}



const CoTermination = (props) => {
  const pageContext = useSelector(state => state.pageContext);
  const selectedOrg = pageContext.selectedOrg;
  const {
    messages,
    setMessages,
  } = props;

  const dispatch = useDispatch();

  // state
  const [coTerminationData, setCoTermination] = useState(null);
  const [expirationDate, setExpiration] = useState(null);
  const [calculateDate, setCalculate] = useState(null);
  const [isOpenRemainDateModal, setOpenRemainDateModal] = useState(false);
  const [isShowRemainDateContainer, setShowRemainDateContainer] = useState(false);

  // init
  const init = useCallback(() => {
    const getData = async () => {
      try {
        dispatch(uiActions.showInnerSpinner());
        const coTermination = await dispatch(getCoTermData(selectedOrg.id)).unwrap();
        const calculate = await dispatch(getCalculateData(selectedOrg.id)).unwrap();
        setCoTermination(coTermination);
        setExpiration({ ...coTermination.expiration });
        setCalculate(calculate);
      } catch (error) {
        setMessages({
          ...messages,
          error: error.code,
          success: null,
        });
      } finally {
        dispatch(uiActions.hideInnerSpinner());
      }
    };

    getData();
  }, [dispatch, selectedOrg.id, messages, setMessages]);


  // useEffect init 
  useEffect(() => {
    init();
  }, []);


  const toCoTerm = useCallback(async () => {
    const postData = {
      userConsent: true,
      hashCode: calculateDate.hashCode,
      id: selectedOrg.id
    }

    try {
      dispatch(uiActions.showSpinner());
      await dispatch(postToCoTerm(postData)).unwrap();
      init()
    } catch (error) {
      setMessages({
        ...messages,
        error: error.code,
        success: null,
      });
    } finally {
      setOpenRemainDateModal(false);
      dispatch(uiActions.hideSpinner());
    }
  }, [selectedOrg.id, calculateDate, dispatch, messages, init, setMessages]);


  const downloadCoTerm = useCallback(async () => {
    try {
      dispatch(uiActions.showSpinner());
      const downloadUrl = await dispatch(getDownloadCoTerm(selectedOrg.id)).unwrap();
      FileSaver.saveAs(downloadUrl);
    } catch (error) {
      setMessages({
        ...messages,
        error: error,
        success: null,
      });
    } finally {
      dispatch(uiActions.hideSpinner());
    }
  }, [selectedOrg.id, dispatch, messages, setMessages]);


  return (
    <div className={`${coTerminationStyle['co-term-container']} layout-container layout-container--column layout-container--fluid`}>
      <div>
        {expirationDate && (
          <ExpirationDateContainer expirationDate={expirationDate} />
        )}
        {coTerminationData && (
          <LicenseStatusContainer
            coTerminationData={coTerminationData}
            downloadCoTerm={downloadCoTerm}
            isShowRemainDateContainer={isShowRemainDateContainer}
            setShowRemainDateContainer={setShowRemainDateContainer}
          />
        )}
        {calculateDate && (
          <RemainDateContainer
            calculateDate={calculateDate}
            isShowRemainDateContainer={isShowRemainDateContainer}
            setOpenRemainDateModal={setOpenRemainDateModal}
          />
        )}
        {calculateDate && (
          <RemainDateModal
            calculateDate={calculateDate}
            toCoTerm={toCoTerm}
            isOpenRemainDateModal={isOpenRemainDateModal}
            setOpenRemainDateModal={setOpenRemainDateModal}
          />
        )}

      </div>
    </div>
  )
}

export default CoTermination;